import UIDescriptionList from 'UIComponents/list/UIDescriptionList';
import UIScrollContainer from 'UIComponents/scroll/UIScrollContainer';
// @ts-expect-error module not typed
import { isDataEmpty } from 'conversations-message-history/email/operators/isDataEmpty';
import CommonMessageHeaderPopoverListItemDescription from './CommonMessageHeaderPopoverListItemDescription';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export let OptionValueType;
(function (OptionValueType) {
  OptionValueType[OptionValueType["Email"] = 0] = "Email";
  OptionValueType[OptionValueType["PhoneNumber"] = 1] = "PhoneNumber";
  OptionValueType[OptionValueType["Date"] = 2] = "Date";
  OptionValueType[OptionValueType["Subject"] = 3] = "Subject";
  OptionValueType[OptionValueType["List"] = 4] = "List";
})(OptionValueType || (OptionValueType = {}));
const StyledDiv = styled.div.withConfig({
  displayName: "CommonMessageHeaderPopoverList__StyledDiv",
  componentId: "dbwnx5-0"
})(["display:contents;"]);
const StyledDt = styled.dt.withConfig({
  displayName: "CommonMessageHeaderPopoverList__StyledDt",
  componentId: "dbwnx5-1"
})(["display:inline;justify-self:end;"]);
const StyledDd = styled.dt.withConfig({
  displayName: "CommonMessageHeaderPopoverList__StyledDd",
  componentId: "dbwnx5-2"
})(["display:inline-flex;color:black !important;"]);
const StyledUIDescriptionList = styled(UIDescriptionList).withConfig({
  displayName: "CommonMessageHeaderPopoverList__StyledUIDescriptionList",
  componentId: "dbwnx5-3"
})(["display:grid;grid-template-columns:auto auto;column-gap:8px;"]);
const CommonMessageHeaderPopoverList = ({
  options
}) => {
  const renderDescriptionListItem = ({
    data,
    label,
    key
  }) => {
    if (isDataEmpty(data.value)) {
      return null;
    }
    return /*#__PURE__*/_jsxs(StyledDiv, {
      children: [/*#__PURE__*/_jsx(StyledDt, {
        children: label
      }), /*#__PURE__*/_jsx(StyledDd, {
        "data-call-metadata-type": key,
        "data-message-metadata-type": key,
        children: /*#__PURE__*/_jsx(CommonMessageHeaderPopoverListItemDescription, {
          name: data.name,
          value: data.value,
          valueType: data.valueType,
          copiableValue: data.copiableValue
        })
      })]
    }, key);
  };
  return /*#__PURE__*/_jsx(UIScrollContainer, {
    maxHeight: 200,
    maxWidth: 450,
    children: /*#__PURE__*/_jsx(StyledUIDescriptionList, {
      className: "p-all-4",
      children: options.map(option => renderDescriptionListItem(option))
    })
  });
};
CommonMessageHeaderPopoverList.displayName = 'CommonMessageHeaderPopoverList';
export default CommonMessageHeaderPopoverList;